import { FormContext, periods } from './useFormContext';
import { roundAmount } from './utils';

export type EffectivePaysystemLimitStat = {
  period: string;
  limit: number;
  usage: number;
  excess: boolean;
  currency: string;
};

export type EffectivePaysystemLimitStats = EffectivePaysystemLimitStat[];

export type EffectivePlayerLimitStat = {
  text: string;
  limit: number;
  usage: number;
  excess: boolean;
  currency: string;
};

export type EffectivePlayerLimitStats = EffectivePlayerLimitStat | null;

// eslint-disable-next-line max-lines-per-function
const useLimitStats = (
  context: FormContext,
  amount: number,
  vendorAmount: number,
  vendorCurrency: string
): [EffectivePaysystemLimitStats, EffectivePlayerLimitStats, boolean] => {
  const { playerPaymentLimitUsage, locales, currency, currencyUsage } = context;

  const effectivePaysystemLimitStats = (() => {
    const stats: EffectivePaysystemLimitStats = [];

    periods.forEach((period) => {
      const limit = +currencyUsage.limits[period];

      if (limit === 0) return;

      const usage = (+currencyUsage.usage[period] || 0) + vendorAmount;

      stats.push({
        period: locales[period],
        limit,
        usage,
        excess: period === 'tnx_min' ? limit > usage : limit !== 0 && limit < usage,
        currency: vendorCurrency,
      });
    });

    return stats;
  })();

  const effectivePlayerLimitStats = ((): EffectivePlayerLimitStats => {
    const stats = playerPaymentLimitUsage;

    if (!stats) return null;

    const { limit, period } = stats;
    const usage = Math.max(+stats.usage + roundAmount(amount, currency), +stats.usage);
    return {
      text: locales.personal_limit_label[period],
      limit: +limit,
      usage,
      excess: +limit < usage,
      currency,
    };
  })();

  const hasLimits = effectivePaysystemLimitStats.length > 0 || !!effectivePlayerLimitStats;

  return [effectivePaysystemLimitStats, effectivePlayerLimitStats, hasLimits];
};

export default useLimitStats;
